import styled from 'styled-components';

export const Div = styled.div`
  height: 53px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.aliceBlue};
  display: flex;
  align-items: center;
  padding: 0 14px;
  justify-content: space-between;
`;
